<template>
  <div class="sm-admin-locations">
    <div class="sm-admin-locations__main">
      <div class="sm-top">
        <div class="sm-wrap lg">
          <div class="sm-top__home-locations">
            <breadcrumbs-block
              v-if="!isMobile && breadcrumbs"
              :crumbs="breadcrumbs"
            />
          </div>
          <div class="sm-top-inner">
            <div class="sm-top__flex">
              <div class="sm-top__row">
                <div class="sm-top__title">
                  <a href="#" @click.prevent="$router.push('locations')">
                    <include-svg :name="'icon-locations'" />
                  </a>
                  <h2>Locations</h2>
                </div>
                <div class="sm-top__control-locations">
                  <input-search
                  v-model="search"
                  :defaultVal="searchStartVal"
                  :placeholder="'Search...'"
                  @submit="sendSearchReq"
                  @input="checkInput"
                  />
                <div
                  v-if="provider.client_level === 2"
                  class="reports-btn"
                  @click.prevent="$router.push('org-reports')"
                >
                  <include-svg :name="'icon-org-admin-reports'" />
                  <span>Organization reports</span>
                  <include-svg :name="'icon-arrow-r-2'" />
                </div>
              </div>
              </div>
            </div>
          </div>
          <ul class="sm-admin-locations__list">
            <li
              class="sm-admin-locations__list-item add-new-location-btn"
              :key="'add-new-location-btn'"
              @click="showAddNewLocationModal"
            >
              <include-svg :name="'icon-add-new-location'" />
              <h3 class="name">Add a new location</h3>
            </li>
            <!-- v-for="(location, index) in locationsList.concat([...locationsList])" -->
            <li
              class="sm-admin-locations__list-item"
              v-for="(location, index) in locationsList"
              :key="index"
              @click="logIn(location)"
              v-if="location.is_active"
            >
              <div
                class="header"
                :class="{
                  active: location.id && location.id === currentClientId,
                }"
              >
                <div class="current">
                  <span v-if="location.id && location.id === currentClientId"
                    >CURRENT LOCATION</span
                  >
                </div>
                <include-svg :name="'icon-home'" />
              </div>
              <img-loader :src="location.image_url" />
              <h3 class="name"><text-truncate :text="`${location.name}`" /></h3>
              <div class="address">
                <text-truncate
                  :text="`${location.client_location.address_1}`"
                />
              </div>
              <div class="address">
                <text-truncate
                  :text="`${location.client_location.address_2}`"
                />
              </div>
            </li>
          </ul>
          <div class="sm-admin-locations__show-more">
            <btn-block
              v-if="canShowMore"
              :type="'show'"
              :text="'Show more'"
              :icon="'icon-arrow-round'"
              @click="getMoreLocations"
            />
          </div>
          <popup-block
            v-if="popup.isOpen"
            :open="popup.isOpen"
            :size="'medium'"
            @close="hideAddNewLocationModal"
          >
            <template slot="popupContent">
              <add-new-location-form
                :key="`add-nwe-location-form`"
                @submit="createLocation"
                @cancel="hideAddNewLocationModal"
              />
            </template>
          </popup-block>
        </div>
      </div>
    </div>
    <sm-spinner :isGlobal="true" :show="showSpinner" />
  </div>
</template>

<script>
import ImgLoader from "@/components/ImgLoader.vue";
import PaginateBlock from "@/components/PaginateBlock";
import Spinner from "@/components/Spinner.vue";
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import AddNewLocationForm from "@/views/admin/pages/locations/AddNewLocationForm";
import Popup from "@/components/Popup";
import { CheckIsStaffDemo } from '@/utils/roles';
import InputSearch from '@/components/InputSearch';

export default {
  name: "locations",
  components: {
    "img-loader": ImgLoader,
    "sm-spinner": Spinner,
    "paginate-block": PaginateBlock,
    "breadcrumbs-block": Breadcrumbs,
    "add-new-location-form": AddNewLocationForm,
    "popup-block": Popup,
    'input-search': InputSearch,
  },
  data() {
    return {
      search: '',
      searchStartVal: '',
      searchTimer: 0,
      searchTimerUpdate: 100,
      seachWait: 1000,
      locations: [],
      more: [],
      canShowMore: false,
      morePages: 0,
      pageLimit: 12,
      currentClientId: null,
      showSpinner: false,
      breadcrumbs: [
        {
          link: "locations",
          name: "org-admin-locations",
          text: "Locations",
          current: true,
        },
      ],
      popup: {
        isOpen: false,
        type: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isDev: 'isDev',
      user: 'auth/user',
      userAccount: "account/userAccount",
      access: "auth/access",
      provider: "provider",
    }),
    locationsList() {
      return [...this.locations, ...this.more];
    },
  },
  created() {
    this.showSpinner = true;
    this.userData().then(() => {
      if (
        this.isAuthorized()
      ) {
        this.currentClientId = this.provider.id;
        this.getLocations();
      } else {
        // this.showSpinner = false;
        this.$router.push("/");
      }
    });

    this.searchTimer = setInterval(() => this.searchTimer += this.searchTimerUpdate, this.searchTimerUpdate);

  },
  methods: {
    ...mapActions({
      getOrgAdminLocations: "auth/getLocationsOfOrgAdmin",
      createNewLocation: "auth/createNewLocation",
      userData: "account/userData",
    }),
    updateRouter(obj) {
      let router = this.$route;

      const query = {
        ...router.query,
        ...obj,
      };

      this.$router.push({
        ...router,
        ...{
          query,
        },
      });
    },
    getLocations() {
      this.showSpinner = true;
      const params = {
        page: 1,
        limit: this.pageLimit - 1,
        search: this.search
      };

      return this.getOrgAdminLocations(params)
        .then((res) => {
          this.locations = res.clients;
          this.canShowMore = res.total_pages > res.page;
          this.showSpinner = false;
        })
        .catch((e) => {
          this.showSpinner = false;
          console.log(e, e.response);
        });
    },
    getMoreLocations() {
      this.showSpinner = true;
      this.morePages++;

      const params = {
        page: this.morePages + 1,
        limit: this.pageLimit,
      };

      this.getOrgAdminLocations(params)
        .then((res) => {
          this.more = [...this.more, ...res.clients];
          this.canShowMore = res.total_pages > res.page;
          this.showSpinner = false;
        })
        .catch((e) => {
          this.showSpinner = false;
          console.log(e, e.response);
        });
    },

    logIn(location) {
      const wlp = window.location.port;
      const port = wlp === "8080" || wlp === "8081" ? ":" + wlp : "";
      if(location.client_domain){
        window.open(
          `http${
            !port ? "s" : ""
          }://${location.client_domain}${port}/customers/login?refresh_token=${
            this.access.refresh_token
          }&access_token=${this.access.token}`
        );
      }else {
        window.open(
          `http${
            !port ? "s" : ""
          }://${location.subdomain}.spheremail.co${port}/customers/login?refresh_token=${
            this.access.refresh_token
          }&access_token=${this.access.token}`
        );
      }
    },
    showAddNewLocationModal() {
      this.popup.isOpen = true;
      this.popup.type = "create-new-location";
    },
    hideAddNewLocationModal() {
      this.popup.isOpen = false;
      this.popup.type = "";
    },
    createLocation(data) {
      this.showSpinner = true;
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        Object.keys(data[key]).forEach((subKey) => {
          if (key !== "common") {
            formData.append(`${key}[${subKey}]`, data[key][subKey]);
          } else {
            formData.append(`client[${subKey}]`, data[key][subKey]);
            formData.append(`account[${subKey}]`, data[key][subKey]);
          }
        });
      });
      this.createNewLocation(formData).then((res) => {
        this.hideAddNewLocationModal();
        this.getLocations().then(() => {
          this.showSpinner = false;
        });
      });
    },
    checkIsStaffDemo: CheckIsStaffDemo,
    isAuthorized() {
      return (
        this.user.privileged_user &&
        (
          this.userAccount.role == "manager" ||
          this.userAccount.is_organization_admin ||
          (
            this.userAccount.role == "super_admin" // &&
            // this.currLocationInTheHardcodedList()
            // disabled currLocationInTheHardcodedList shows enhancements for all locations
          )
        )
      )
    },
    // currLocationInTheHardcodedList() {
    //   return this.isDev || this.checkIsStaffDemo(this.provider.id)
    // },
    clearQueryParams(paramArr) {
      let query = Object.assign({}, this.$route.query);
      paramArr.forEach(param => delete query[param]);

      this.$router.push({query});
    },
    sendSearchReq() {
      this.$router.push({
        query: {
          ...this.$route.query,
          ...{
            search: this.search
          }
        }
      });
    },
    checkInput() {
      if (this.search.length < 2) {
        if (!this.search.length)
          this.clearQueryParams(['search']);
          
        return;
      }

      setTimeout(() => {
        if (this.searchTimer > this.seachWait) {
          this.sendSearchReq();
          this.searchTimer = 0;
        }
      }, this.seachWait);
    }
  },
  watch: {
    locations(val) {
      if (val.length < 1 && !this.search) {
        this.$router.push("/");
      }
    },
    "$route.query"(val) {
      if(val.page) this.pager.page = val.page;
      if(val.limit) this.pager.limit = val.limit;
      this.getLocations();
    },
  },
};
</script>



<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
@use "@/assets/scss/pages/common/mail/_top.scss";

.sm-admin-locations {
  margin-top: 40px;
  margin-bottom: 150px;

  & .sm-top__row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & .sm-top__control-locations{
      display: flex;
      gap:20px;
      width: auto;
      flex: 1;
      justify-content: flex-end;
      

      & > .sm-input-wrap {
       width: 200px;
       min-width: 110px; 
       max-width: 50%;
       align-items: center;
      }

      & .reports-btn {
      display: flex;
      align-items: center;
      width: 210px;
      height: 40px;
      padding: 10px;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 600;
      background-color: var(--sys-bg);
      cursor: pointer;
      color: var(--sys);

      & .sm-icon-org-admin-reports {
        width: 22px;
        height: 22px;
        margin-right: 5px;
      }

      & span {
        margin-right: 5px;
      }

      & .sm-icon-arrow-r-2 {
        margin-top: 3px;
      }

      &:hover {
        font-weight: bolder;
        & span {
          margin-right: 10px;
        }
      }
      }

      @include media("<=small") {
        margin-top: 30px;
        justify-content: space-between;
        width: 100%;


        & > .sm-input-wrap {
          width: 200px;
          min-width: 110px; 
          max-width: 200px;
          }
      }

    }
  }

  & .sm-top__title {
    & svg {
      stroke: var(--white);
      width: 1.2em;
      height: 1.2em;
    }
  }

  & .sm-top__home-locations {
    margin-top: 40px;
  }

  &__list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;
    max-width: 100%;
    gap: 20px;

    &-item {
      border: 1px dashed var(--grey-line);
      display: flex;
      flex-direction: column;
      width: 315px;
      height: 240px;
      padding: 20px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      cursor: pointer;

      & .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        & .current {
          display: block;
          margin-right: auto;
          font-size: 14px;
          color: var(--sys);
        }

        & svg {
          fill: none;
          stroke: var(--sys-icon);
        }

        &.active {
          svg {
            stroke: var(--sys);
            fill: var(--sys);
          }
        }
      }

      & .sm-img-loader {
        display: flex;
        justify-content: flex-start;
        max-height: 50px;
        max-width: 100%;
        position: relative;
      }

      & .name {
        font-size: 22px;
        margin-top: 20px;
      }

      & .address {
        font-size: 16px;
        color: var(--grey-add);
      }

      &.add-new-location-btn {
        box-shadow: none;
        background-color: var(--grey-bg);
        display: flex;
        justify-content: center;
        align-items: center;

        & .name {
          margin-top: 13px;
        }
      }
    }
  }
  &__show-more {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>
